import type { AvailabilityDayModel, AvailabilitySlotModel } from "../../Core/Models/BookingModels";

export const CalendarLegendPiece = ({ source }: { source: "api" | "fallback" }) => (
  <div className="flex flex-wrap items-center gap-3 text-xs font-black uppercase text-cmj-mist">
    <span className="rounded-md border border-cmj-gold/30 bg-cmj-gold/10 px-3 py-1 text-cmj-gold">
      {source === "api" ? "Live availability" : "Fallback availability"}
    </span>
    <span className="inline-flex items-center gap-2">
      <span className="h-3 w-3 rounded-sm bg-cmj-red" />
      Selectable
    </span>
    <span className="inline-flex items-center gap-2">
      <span className="h-3 w-3 rounded-sm border border-white/20 bg-transparent" />
      Unavailable
    </span>
  </div>
);

export const CalendarDayButtonPiece = ({
  day,
  isActive,
  onSelect,
}: {
  day: AvailabilityDayModel | null;
  isActive: boolean;
  onSelect: (date: string) => void;
}) => {
  if (!day) {
    return <div className="h-24 rounded-md border border-transparent" />;
  }

  return (
    <button
      className={[
        "studio-calendar-day flex h-24 flex-col items-start justify-between rounded-md border p-4 text-left transition",
        day.isAvailable
          ? "border-white/10 bg-white/5 hover:border-cmj-gold/40 hover:bg-white/10"
          : "cursor-not-allowed border-white/5 bg-cmj-base/50 opacity-40",
        isActive ? "border-cmj-red bg-cmj-red/10" : "",
      ].join(" ")}
      aria-pressed={isActive}
      aria-label={`${day.label}, ${day.isAvailable ? "available" : "unavailable"}`}
      disabled={!day.isAvailable}
      onClick={() => onSelect(day.date)}
      type="button"
    >
      <span className="text-xs font-black uppercase text-cmj-mist">
        {new Date(`${day.date}T12:00:00`).toLocaleDateString("en-US", {
          weekday: "short",
        })}
      </span>
      <span className="font-display text-3xl uppercase text-white">
        {new Date(`${day.date}T12:00:00`).getDate()}
      </span>
      <span className="text-xs font-black uppercase text-cmj-gold">
        {day.isAvailable ? `${day.slots.length} ${day.slots.length === 1 ? "slot" : "slots"}` : "—"}
      </span>
    </button>
  );
};

export const TimeSlotButtonPiece = ({
  slot,
  isSelected,
  onSelect,
}: {
  slot: AvailabilitySlotModel;
  isSelected: boolean;
  onSelect: (slot: AvailabilitySlotModel) => void;
}) => (
  <button
    className={[
      "rounded-md border px-4 py-3 text-sm font-black uppercase transition",
      isSelected
        ? "border-cmj-red bg-cmj-red text-white"
        : "border-white/10 bg-white/5 text-cmj-mist hover:border-cmj-gold/40 hover:text-white",
    ].join(" ")}
    aria-pressed={isSelected}
    onClick={() => onSelect(slot)}
    type="button"
  >
    {slot.label}
  </button>
);
